var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('router-view'),_c('router-link',{staticClass:"back",attrs:{"to":"/work","tag":"a"}},[_vm._v("« Back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }